module.exports = __webpack_public_path__ + "static/assets/f5fdda5196deea168f2c51165c98f0dc.gif";